
<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
          <p>輕鬆影片上字幕</p>
          <p>輕鬆AI影片分析</p>
          <p>輕鬆影片翻譯</p>
          <p>輕鬆影音轉文字</p>
        </div>
        <span id="text1"></span>
      </template>
      <template slot="landing_description">AI自動幫你影片轉文字、上字幕、翻譯、分析<br>支援超過40種語言</template>

      <template slot="intro_video">
          <!-- <video playsinline class="intro-video" src="https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2Fch_crop_com.mp4?alt=media&token=7bd7d213-cf0e-4d4b-8cc7-d3506594caa1" autoplay frameborder="0" height="350" width="575" muted></video> -->
          <video playsinline class="intro-video" :src='"@/assets/video/landing_ch.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
          
      </template>

      <template slot="start_your_trial">馬上註冊 - 贈送15分鐘!</template>

      <!-- <template slot="as_seen_on"><h1>媒體報導</h1></template>
      <template slot="use_case_title">使用族群</template>
      <template slot="youtubers">會議記錄</template>
      <template slot="youtubers_question">需要為您的會議<span style="color:#00d1b2;">標記</span>說話的人物嗎?</template>
      <template slot="youtubers_desc">上傳會議影片後,將剩下的交給我們。從語音轉文字到時間同步到人性化自動分段到做人物標記,全部幫你搞定。</template> -->
      <!-- <template slot="journalists">Podcasters</template>
      <template slot="journalists_question">需要把<span style="color:#00d1b2;">錄音檔</span>轉為有<span style="color:#00d1b2;">字幕的影片</span>嗎?</template>
      <template slot="journalists_desc">上傳錄音檔和一張高清圖片，我們將幫您導出客製化背景的字幕影片。讓您的頻道不只有聽眾也能有觀眾。</template>
      <template slot="translators">字幕影片</template>
      <template slot="translators_question">需要為您的影片導出<span style="color:#00d1b2;">雙語字幕</span>嗎?</template>
      <template slot="translators_desc">轉換為文字後，讓你有50種語言的選擇來自動翻譯，並可導出任何兩種語言組合的雙語字幕影片。</template> -->
      <!-- <template slot="as_seen_on"><h1>媒體報導</h1></template> -->

      <template slot="use_case_title">多功能平台</template>
      <template slot="youtubers">影音轉文字</template>
      <template slot="youtubers_question">影音檔自動轉成文字後<span style="color:#00d1b2;">上單一或雙語字幕</span></template>

      <template slot="journalists">AI分析</template>
      <template slot="journalists_question">AI幫你影片總結，影片下標題，提供影片專屬的<span style="color:#00d1b2;">ChatGPT</span></template>

      <!-- <template slot="youtubers">逐字稿</template>
      <template slot="youtubers_question">影音檔,Youtube,Zoom等<span style="color:#00d1b2;">自動轉成文字</span></template>

      <template slot="journalists">上字幕（雙語）</template>
      <template slot="journalists_question">影片自動轉成文字並<span style="color:#00d1b2;">自動分段</span></template> -->

      <template slot="translators">影片翻譯</template>
      <template slot="translators_question">支援超過<span style="color:#00d1b2;">50種語言</span>的自動影片翻譯</template>
      <template slot="speaker">人物標記</template>
      <template slot="speaker_question">會議紀錄、錄音檔、Podcast等影音檔轉為逐字稿後自動標記人物</template>

      <template slot="timealign">TXT文字上時間軸</template>
      <template slot="timealign_question">我們將您提供的文字加上時間軸和標記人物</template>

      <template slot="audiotomp4">錄音檔轉影片</template>
      <template slot="audiotomp4_question">錄音檔轉文字後上傳一張圖片，導出有字幕的客製化影片</template>

      <template slot="importsrt">TXT或SRT字幕編輯</template>
      <template slot="importsrt_question">自動文字加上時間軸或提供SRT字幕檔並使用我們強大的編輯平台來校稿</template>

      <template slot="share">企業級功能和安全</template>
      <template slot="share_question">平台功能、影片的客製化權限、分鐘數共享、共同逐字稿編輯和影片剪輯，管理起來更有效</template>

      <template slot="learnmore">了解更多</template>



      <template slot="simple_workflow">流程簡單, 順暢</template>
      <template slot="upload">上傳</template>
      <!-- <template slot="upload_description">將影音檔上傳到Taption平台，或者直接貼上YouTube、影音檔連接。專業的影片轉文字線上服務，快速精準地將影片語音轉成文字。</template> -->
      <template slot="upload_description">將影音檔上傳到Taption平台，或直接從YouTube下載、Webex下載、Zoom下載，或從Google Drive下載。並且支援多種格式自動轉檔，快速精準地將影片語音轉成文字。</template>
      <template slot="edit_translate">編輯</template>
      <template slot="edit_translate_description">在我們的影片轉文字線上編輯平台，文字自動同步時間軸。無論是編輯文字、字幕分段，或是影片剪輯都讓你省去手動調時間的步驟！</template>
      <template slot="transcribe">AI分析</template>
      <template slot="transcribe_description">對影片問任何問題或指令，利用AI分析，讓你擁有專屬的ChatGPT! 不僅可快速獲得影片總結、影片摘要，還能精確抽取影片要點，輕鬆掌握核心內容。</template>
      <template slot="translate">翻譯</template>
      <template slot="translate_description">我們的線上翻譯軟體有效解決傳統自動翻譯中字幕不同步和過於直白的問題，確保清準流暢。支援40+語言，包含常見的中翻英、英翻中、日文翻譯、韓文翻譯、越南翻譯等。</template>
      <template slot="export">導出</template>
      <template slot="export_description">完成字幕編輯和影片剪輯後,能以多種格式導出 (單語言或雙語字幕崁入影片MP4,SRT,VTT,PDF,TXT)。</template>
      <template slot="try_it_now">馬上試!</template>



      <template slot="editing_platform_desc1">透過底部時間軸功能讓你輕鬆剪輯影片。當剪輯動作與字幕重疊時，Taption會自度移除文字並調整時間，確保字幕的準確性和與時間軸的同步。我們的線上影片剪輯是快速編輯的理想選擇，輕鬆實現專業的字幕影片成品。</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <div class="play-button" v-show="!videoState.video1">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
                  <video id="video1" ref="video1" playsinline preload="none" poster="../assets/images/thumbnail/cut_thumbnail_zh.webp" class="unique-video" :src='"@/assets/video/Trim_Cut_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
     <template slot="editing_platform">強大編輯平台</template>
      <template slot="editing_platform_desc0">Taption不僅支援字幕和逐字稿編輯，還可以透過字幕進行精準的影片剪輯。平台會自動同步調整其他字幕的時間，以匹配剪輯後的影片，確保播放時流暢無礙，簡化了字幕編輯和影片剪輯的流程。</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" poster="../assets/images/thumbnail/trim_thumbnail_zh.webp" class="intro-video" :src='"@/assets/video/Trim_Chinese.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>
      <template slot="editing_platform_desc2">「AI分析」功能能深入解析上傳的影片，支援影片總結、列出要點、搜尋內容及回答問題，提升對影片的理解與互動效率。此外，平台還提供了一系列常用模板，例如一鍵生成YouTube影片章節、自動生成影片標題、以及影片錯字的自動修正等功能，進一步簡化了影片分析與編輯過程。</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_zh.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">影片轉成逐字稿後，這個功能讓您在影片的特定時間點添加備忘錄，以留下註解或文字筆記，方便其他用戶查看。透過快速導航到相應的時間軸，不同使用者可以快速查閱備忘錄相對應的影片橋段，提高了影音轉文字的整體效率。</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_zh.webp" class="unique-video" :src='"@/assets/video/Memo_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
                  

      <template slot="low_cost">價格親民</template>
      <template slot="title_basic">影片長度計價</template>
      <template slot="basic_cost_usd">$8</template>
      <template slot="basic_cost_ntd">(240 NTD)</template>
      <template slot="unit">美金</template>
      <template slot="hour">小時</template>
      <template slot="basic_feature5">充值<span style="color: #00d1b2;">60分鐘</span></template>
      <template slot="basic_feature1">自動將影音檔轉成文字</template>
      <template slot="basic_feature2">支援40多種語言</template>
      <template slot="basic_feature3">精準時間對照編輯器</template>
      <template slot="basic_feature4">50多種語言翻譯</template>
      <template slot="basic_feature7">個人AI辭典</template>
      <template slot="basic_feature6">可供商業相關之用途</template>
      <template slot="basic_feature8">雙語字幕崁入影片導出</template>

      <template slot="title_premium">高級訂閱</template>
      <template slot="premium_cost_usd">$12</template>
      <template slot="premium_cost_ntd">(360 NTD)</template>
      <template slot="premium_basic_cost_usd">$6</template>
      <template slot="month">月</template>
      
      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>所有『影片長度計價』功能</template>
      <template slot="premium_feature1">每個月贈送<span style="color: #00d1b2;">120分鐘</span> <br><span style="color:#797676;font-size:14px;font-weight: 100;">(可跨月累積，有效至訂閱取消為止)</span></template>
      <template slot="premium_feature1_tooltip">此分鐘沒用完可以持續累積，有效直到取消訂閱為止。<br>相較於另外購買的分鐘數，會優先使用此分鐘。<br>另購買分鐘不會因取消訂閱而失效。</template>
      <template slot="premium_feature2">如需更多分鐘, 以7.5折優惠價格購買</template>
      <template slot="premium_feature3">字幕崁入影片不扣分鐘，無限制導出</template>
      <template slot="premium_feature4">分享給其他用戶編輯</template>
      <template slot="premium_feature5">錄音檔轉為有字幕的影片檔</template>
      <template slot="premium_feature6">影片剪輯 (字幕自動調整)</template>

      <template slot="title_corp">大量訂閱</template>
      <template slot="bulk_cost_usd">$69</template>
      <template slot="bulk_cost_ntd">(2070 NTD)</template>
      <template slot="bulk_basic_cost_usd">$4</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>所有『影片長度計價』和『高級訂閱』功能</template>
       <template slot="bulk_feature2">如需更多分鐘, 以3.7折優惠價格購買</template>
      <template slot="premium_feature1_bulk">每個月贈送<span style="color: #00d1b2;">1000分鐘</span><br><span style="color:#797676;font-size:14px;font-weight: 100;">(可跨月累積，有效至訂閱取消為止)</span></template>
      <template slot="bulk_feature1">提供公司名稱以及統一編號的發票下載</template>
       <template slot="bulk_feature3">加入用戶共享分鐘</template>
       <template slot="bulk_feature4">針對加入用戶提供6種權限管理</template>

      <template slot="go_to_price">了解更多</template>
    </LandingPage>
</template>

<script>
import LandingPage from "./LandingPage";

export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   


    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }


    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }


    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }

    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           